

import React, {useEffect, useState} from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { getOrderNotification } from '../../services/OrderNotification/getOrderNotification';
import { Link } from 'react-router-dom';
import { getStoreLocalData } from '../../utils/localStorage';

const OrderNotification = ({
    orderNotificationVisible,
    setOrderNotificationVisible,
    mobileNumber,
    orderNotificationMessageType,
    storeCustomerId,
    storeId,
    bookingOrderId,
    userRole,
  }) => {
  const [orderNotificationData, setOrderNotificationData] = useState([]);

  const { storeLocalData } = getStoreLocalData();
  const countryCode = storeLocalData?.countryCode;

  // const fetchOrderNotification = () => {
  //   getOrderNotification(storeCustomerId, storeId, bookingOrderId)
  //     .then(response => {
  //       if (!response.data.error) {
  //         // const Res = response.data;
  //         let filteredData = response.data;
  //         if (userRole === 'BY_RIDER') {
  //           filteredData = response.data.filter(
  //             item => item.templateType === 'ORDER_CHALLAN_TEMPLATE',
  //           );
  //         }
  //         setOrderNotificationData(filteredData);
  //       }
  //     })
  //     .catch(err => {
  //       console.error('Error:', err);
  //     });
  // };

  const fetchOrderNotification = () => {
    getOrderNotification(storeCustomerId, storeId, bookingOrderId)
      .then(response => {
        if (!response.data.error) {
          let filteredData = response.data;
  
          // Step 1: Filter for rider if needed
          if (userRole === 'BY_RIDER') {
            filteredData = filteredData.filter(
              item => item.templateType === 'ORDER_CHALLAN_TEMPLATE'
            );
          }
  
          // Step 2: Keep only the latest notification per templateType
          const latestPerTemplateMap = {};
          filteredData.forEach(item => {
            const existing = latestPerTemplateMap[item.templateType];
            const currentCreated = new Date(item.createdDate).getTime();
  
            if (!existing || currentCreated > new Date(existing.createdDate).getTime()) {
              latestPerTemplateMap[item.templateType] = item;
            }
          });
  
          // Step 3: Convert map to array
          const dedupedData = Object.values(latestPerTemplateMap);
  
          // Optional: sort by date descending
          dedupedData.sort(
            (a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
          );
  
          // Set state
          setOrderNotificationData(dedupedData);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };
  


  useEffect(() => {
    if (bookingOrderId !== undefined) fetchOrderNotification();
  }, [orderNotificationVisible]);


  const handleMessage = (item, orderNotificationMessageType) => {
    const mobile = mobileNumber;
    const body = `${item.notification}`;

    if (!mobile) {
      return alert('Mobile number is invalid');
    }

    // Remove any non-numeric characters and check if the number starts with a '+'
    let formattedMobile = mobile.replace(/[^\d+]/g, '');  // Remove non-numeric and non-plus characters
    
    if (!formattedMobile.startsWith('+')) {
      formattedMobile = `${countryCode}${formattedMobile}`;  // Add country code only if not already present
    }

    let url = '';
    
    if (orderNotificationMessageType === 'SMSMessage') {
      url = `sms:${formattedMobile}?body=${encodeURIComponent(body)}`;
    } else {
      url = `https://api.whatsapp.com/send?text=${encodeURIComponent(body)}&phone=${formattedMobile}`;
    }

    window.open(url, '_blank');
  };



  const renderCardOrderNotification = () => {
        return orderNotificationData?.map((item, index) => (
      <div className='cursor-pointer'
        onClick={() => handleMessage(item, orderNotificationMessageType)} // Set selectedNotification when an item is pressed
      >
        <div  
         className="border-bottom-2" style={{color:"#2B70D7"}}>
          <div
            className='mx-4'>
            <p
              className='text-2xl font-medium ' style={{color:"#000"}}
              >
              {item.templateType.replace(/_/g, ' ').replace(/TEMPLATE/g, '')}
            </p>
          </div>
        </div>
      </div>
    ));
  };


  const handleModalClose = () => {
    setOrderNotificationVisible(false);
    
  };


  return (

    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={orderNotificationVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!orderNotificationVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                 "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
              <i
              className="pi pi-whatsapp "
              
              style={{ fontSize: "30px", cursor: "pointer", color: "#fff" }}
            ></i>
                {/* <Icon
                      name={
                        orderNotificationMessageType === 'SMSMessage'
                          ? 'message-processing'
                          : 'whatsapp'
                      }
                      size={
                        windowWidth >= 620
                          ? 50
                          : windowWidth > 420 && windowWidth < 620
                          ? 42
                          : 35
                      }
                      color="#008EFF"
                      style={styles.invoiceBtnText}
                    /> */}
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Select Notification
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
              <div
                 className='mb-4'>
                {orderNotificationData.length > 0 ? (
                    renderCardOrderNotification()
                ) : (
                  <div>
                    <p
                      className='text-2xl font-semiBold'>
                      No Notification Found
                    </p>
                    <p
                      className='text-2xl font-semiBold'>
                      Please Contact your administrator
                    </p>
                  </div>
                )}
              </div>
            </div>
         
    )}
        ></Dialog>
    </div>
  );
};

export default OrderNotification;



